var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center justify-content-between w-100 cursor-pointer",on:{"click":_vm.changeSort}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('i',{staticClass:"las",class:{
      'la-sort-up': (_vm.sortKey === _vm.value.key && _vm.value.sort === 'asc') || _vm.sortKey !== _vm.value.key,
      'la-sort-down': _vm.sortKey === _vm.value.key && _vm.value.sort === 'desc',
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }